import React from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';


const Footer = () => {
  return (
    <>
      <div className="container-fluid footer py-5 wow fadeIn" data-wow-delay="0.2s" >
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-secondary mb-4">Contact Info</h4>
                <a href='https://share.google/I6OxTjR8FurkQVoHM' target="_blank"><i className="fa fa-map-marker me-2" /> Railway Station, Station Rd, Railway Colony, Satna, Madhya Pradesh 485001</a>
                <a href="mailto:sp.neelendra100@gmail.com"><i className="fas fa-envelope me-2" /> sp.neelendra100@gmail.com</a>
                <a href="tel:+91 7389578180"><i className="fas fa-phone me-2" /> +91 7389578180</a>
                <div className="d-flex align-items-center">
                  <i className="fas fa-share fa-2x text-secondary me-2" />
                  {/* <a className="btn mx-1" to><i className="fab fa-twitter" /></a> */}
                  <a className="btn mx-1" href='https://www.instagram.com/shiv_travels_8180?igsh=M2YzcHNzdWYwY29j' target="_blank" ><i className="fab fa-instagram" /></a>
                  <a className="btn mx-1" to><i className="fab fa-facebook-f" /></a>
                  <a className="btn mx-1" to><i className="fab fa-youtube" /></a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-secondary mb-4">Opening Time</h4>
                <div className="mb-3">
                  {/* <h6 className="text-muted mb-0">Mon - Friday:</h6> */}
                  <p className="text-white mb-0">24 Hrs Booking Open</p>
                </div> 
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-secondary mb-4">Our Services</h4>
                <Link to="/" className><i className="fas fa-angle-right me-2" /> Home</Link>
                <Link to="/about" className><i className="fas fa-angle-right me-2" /> About Us</Link>
                <Link to="/our-vehicles" className><i className="fas fa-angle-right me-2" /> Our Vehicles</Link>
                <Link to="/contact-us" className><i className="fas fa-angle-right me-2" /> Contact Us</Link>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item">
                <h4 className="text-secondary mb-4">Newsletter</h4>
                <p className="text-white mb-3">The best chauffeur-driven taxi service in India is Shiv Travels Taxi Services.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid copyright py-4">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-white"><a to="#" className="border-bottom text-white"></a>2026 © Shiv Travels |  <a href="tel:+91 8982471422" style={{color:"white"}}> Designed by Web solution & digital marketing</a></span>
            </div>
            
          </div>
        </div>
      </div>


      {/* Back to Top */}

      <a href="#" className="btn btn-primary btn-lg-square back-to-top"><i className="fa fa-arrow-up" /></a>



      <WhatsappIcon />



    </>
  )
}

export default Footer